import axios from "axios";
import React, { useEffect, useState } from "react";
import { FaSearch, FaEdit, FaTrash, FaPrint, FaPlus } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Apiurl from "../../environment/Apiurl";

const JobSheet = () => {
  const [getData, setGetData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Modal states
  const [showModal, setShowModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const navigate = useNavigate();

  const [privileges, setPrivileges] = useState(null);

  // Fetch privileges from localStorage
  useEffect(() => {
    const getaccess = localStorage.getItem("role");
    setPrivileges(getaccess);
  }, []);

  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  // Dummy data
  useEffect(() => {
    setLoading(true);
    const fetchData = async (req, res) => {
      try {
        const response = await axios.get(`${Apiurl}/job-sheet`);
        setGetData(response.data || []);
        setLoading(false);
      } catch (error) {
        console.log(error.message);
      }
    };

    fetchData();
  }, []);

  // DELETE confirm
  const confirmDelete = (id) => {
    setDeleteId(id);
    setShowModal(true);
  };

  const handleDelete = async () => {
    try {
      await axios.delete(`${Apiurl}/job-sheet/${deleteId}`);
      setGetData((prev) => prev.filter((item) => item._id !== deleteId));
      setShowModal(false);
      setDeleteId(null);
    } catch (error) {
      console.log(error);
      alert("Failed to delete Job Sheet");
    }
  };

  const filteredData = getData.filter((item) => {
    const search = searchTerm.toLowerCase();

    return (
      (item.sheet_no?.toLowerCase() || "").includes(search) ||
      (item.customer_name?.toLowerCase() || "").includes(search) ||
      (item.mobile_number?.toLowerCase() || "").includes(search) ||
      (item.mobile_brand?.toLowerCase() || "").includes(search) ||
      (item.mobile_model?.toLowerCase() || "").includes(search) ||
      item.complaint_details?.some(
        (c) =>
          c.complaint_name?.toLowerCase().includes(search) ||
          c.complaint_no?.toLowerCase().includes(search),
      )
    );
  });

  const indexOfLastItem =
    itemsPerPage === "All"
      ? filteredData.length
      : currentPage * parseInt(itemsPerPage);

  const indexOfFirstItem =
    itemsPerPage === "All" ? 0 : indexOfLastItem - parseInt(itemsPerPage);

  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages =
    itemsPerPage === "All"
      ? 1
      : Math.ceil(filteredData.length / parseInt(itemsPerPage));

  const getPageList = () => {
    const pages = [];

    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 4) {
        pages.push(1, 2, 3, 4, 5, "...", totalPages);
      } else if (currentPage >= totalPages - 3) {
        pages.push(
          1,
          "...",
          totalPages - 4,
          totalPages - 3,
          totalPages - 2,
          totalPages - 1,
          totalPages,
        );
      } else {
        pages.push(
          1,
          "...",
          currentPage - 1,
          currentPage,
          currentPage + 1,
          "...",
          totalPages,
        );
      }
    }

    return pages;
  };

  const pages = getPageList();

  const handlePageClick = (page) => {
    if (page !== "..." && page !== currentPage) {
      setCurrentPage(page);
    }
  };

  if (loading) {
    return (
      <div
        className="container-fluid p-3 d-flex justify-content-center align-items-center"
        style={{ height: "50vh" }}
      >
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid p-3">
      {error && (
        <div
          className="alert alert-danger alert-dismissible fade show"
          role="alert"
        >
          {error}

          <button
            type="button"
            className="btn-close"
            onClick={() => setError(null)}
          ></button>
        </div>
      )}

      <div className="d-flex justify-content-end mb-3">
        {(privileges === "Admin" ||
          privileges === "Manager" ||
          privileges === "Receptionist") && (
          <button
            className="btn btn-sm text-white"
            style={{ backgroundColor: "#2e9290" }}
            onClick={() => {
              navigate("/job-sheet/add-job-sheet");
            }}
          >
            <FaPlus className="me-2" />
            Add Job Sheet
          </button>
        )}
      </div>

      <div className="card">
        <div className="card-body">
          {/* Search + Items per page */}
          <div className="row mb-2">
            <div className="col-md-2">
              <div className="input-group">
                <span className="input-group-text">
                  <i className="fas fa-table"></i>
                </span>

                <select
                  className="form-select"
                  value={itemsPerPage}
                  onChange={(e) => {
                    setCurrentPage(1);
                    setItemsPerPage(e.target.value);
                  }}
                >
                  <option value="All">Show All</option>

                  {[5, 10, 20, 50, 100].map((n) => (
                    <option key={n} value={n}>
                      Show {n}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="col-md-7"></div>

            <div className="col-md-3">
              <div className="d-flex align-items-center">
                <div className="position-relative w-100">
                  <input
                    type="text"
                    className="form-control pe-5"
                    placeholder="Search"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />

                  <FaSearch
                    className="text-muted"
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "35%",
                      transform: "translateY(-50%)",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Table */}
          <div className="table-responsive">
            <table className="table">
              <thead className="text-center">
                <tr>
                  <th style={{ backgroundColor: "#2e9290", color: "white" }}>
                    S.No
                  </th>

                  <th style={{ backgroundColor: "#2e9290", color: "white" }}>
                    Sheet No
                  </th>

                  <th style={{ backgroundColor: "#2e9290", color: "white" }}>
                    Date
                  </th>

                  <th style={{ backgroundColor: "#2e9290", color: "white" }}>
                    Time
                  </th>

                  <th style={{ backgroundColor: "#2e9290", color: "white" }}>
                    Customer Name
                  </th>

                  <th style={{ backgroundColor: "#2e9290", color: "white" }}>
                    Compliant
                  </th>

                  <th style={{ backgroundColor: "#2e9290", color: "white" }}>
                    Actions
                  </th>
                </tr>
              </thead>

              <tbody className="text-center">
                {currentData.length === 0 ? (
                  <tr>
                    <td colSpan="11" className="text-center">
                      {searchTerm
                        ? "No job sheet found matching your search"
                        : "No job sheet available"}
                    </td>
                  </tr>
                ) : (
                  currentData.map((item, index) => (
                    <tr key={index} className="align-middle">
                      <td>
                        {itemsPerPage === "All"
                          ? index + 1
                          : (currentPage - 1) * parseInt(itemsPerPage) +
                            index +
                            1}
                      </td>

                      <td>{item.sheet_no || "N/A"}</td>

                      <td>
                        {item.date
                          ? new Date(item.date).toLocaleDateString("en-GB")
                          : "N/A"}
                      </td>

                      <td>{item.time || "N/A"}</td>

                      <td>{item.customer_name || "N/A"}</td>

                      <td>
                        {item.complaint_details?.length > 0
                          ? item.complaint_details.map((complaint, index) => (
                              <div key={index}>{complaint.complaint_name}</div>
                            ))
                          : "N/A"}
                      </td>

                      <td>
                        {(privileges === "Admin" ||
                          privileges === "Manager") && (
                          <button
                            className="btn btn-sm border-0 me-1"
                            style={{ backgroundColor: "transparent" }}
                            onClick={() => {
                              navigate(
                                `/job-sheet/update-job-sheet/${item._id}`,
                              );
                            }}
                          >
                            <FaEdit className="text-info" size={16} />
                          </button>
                        )}

                        {privileges === "Admin" && (
                          <button
                            className="btn btn-sm border-0 me-1"
                            style={{ backgroundColor: "transparent" }}
                            onClick={() => confirmDelete(item._id)}
                          >
                            <FaTrash className="text-danger" size={16} />
                          </button>
                        )}

                        {(privileges === "Admin" ||
                          privileges === "Manager" ||
                          privileges === "Receptionist") && (
                          <button
                            className="btn btn-sm border-0"
                            style={{ backgroundColor: "transparent" }}
                            onClick={() => {
                              navigate(
                                `/job-sheet/invoice-job-sheet-bill/${item._id}`,
                              );
                            }}
                          >
                            <FaPrint className="text-warning" size={16} />
                          </button>
                        )}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          <div className="container">
            <div className="d-flex justify-content-between align-items-center p-3 border-top gap-2">
              <button
                className="btn btn-outline-secondary d-flex align-items-center gap-2"
                onClick={() => handlePageClick(currentPage - 1)}
                disabled={currentPage === 1}
                style={{
                  visibility: filteredData.length > 0 ? "visible" : "hidden",
                }}
              >
                <i className="fas fa-chevron-left"></i>

                <span className="d-none d-sm-inline">Previous</span>
              </button>

              <div
                className="d-flex overflow-auto flex-nowrap gap-2 px-2"
                style={{ maxWidth: "100%" }}
              >
                {pages.map((page, index) => (
                  <button
                    key={index}
                    className={`btn btn-sm px-3 flex-shrink-0 ${
                      page === currentPage
                        ? "text-white"
                        : "btn-outline-secondary"
                    }`}
                    style={
                      page === currentPage
                        ? {
                            backgroundColor: "#2e9290",
                            border: "none",
                          }
                        : {}
                    }
                    onClick={() => handlePageClick(page)}
                    disabled={page === "..."}
                  >
                    {page}
                  </button>
                ))}
              </div>

              <button
                className="btn btn-outline-secondary d-flex align-items-center gap-2"
                onClick={() => handlePageClick(currentPage + 1)}
                disabled={currentPage === totalPages}
                style={{
                  visibility: filteredData.length > 0 ? "visible" : "hidden",
                }}
              >
                <span className="d-none d-sm-inline">Next</span>

                <i className="fas fa-chevron-right"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      {showModal && (
        <div
          className="modal fade show"
          style={{
            display: "block",
            backgroundColor: "rgba(0,0,0,0.6)",
          }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content shadow-lg border-0 rounded-4">
              <div className="modal-body text-center p-4">
                {/* Warning Icon */}
                <div
                  className="d-flex justify-content-center align-items-center mb-3"
                  style={{
                    width: "70px",
                    height: "70px",
                    borderRadius: "50%",
                    backgroundColor: "#fdecea",
                    margin: "0 auto",
                  }}
                >
                  <i
                    className="fas fa-exclamation-triangle"
                    style={{
                      fontSize: "32px",
                      color: "#e74c3c",
                    }}
                  ></i>
                </div>

                {/* Title */}
                <h4 className="fw-bold text-dark">Delete Job Sheet?</h4>

                <p className="text-muted mb-4">
                  Are you sure you want to delete this job sheet
                  <br />
                  This action{" "}
                  <span className="fw-bold text-danger">cannot</span> be undone.
                </p>

                {/* Buttons */}
                <div className="d-flex justify-content-center gap-3">
                  <button
                    className="btn btn-light px-4 py-2 border rounded-pill"
                    onClick={() => setShowModal(false)}
                  >
                    <i className="fas fa-times me-2"></i>
                    Cancel
                  </button>

                  <button
                    className="btn text-white px-4 py-2 rounded-pill"
                    style={{ backgroundColor: "#e74c3c" }}
                    onClick={handleDelete}
                  >
                    <i className="fas fa-trash me-2"></i>
                    Yes, Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default JobSheet;
